import isNumber from 'lodash/isNumber';
import { CogniteAnnotation } from 'types';

type GhostCoordinatesCandidate = { id: string; x?: unknown; y?: unknown };
type GhostCoordinates = {
  id: `ghost-${string}`;
  x: number;
  y: number;
};
type AnnotationWithCustomOffset = CogniteAnnotation & {
  customOffset?: { x?: unknown; y?: unknown };
};
type AnnotationWithNumericCustomOffset = CogniteAnnotation & {
  customOffset: { x: number; y: number };
};

export const isGhostAnnotationId = (annotationId: string): boolean =>
  annotationId.startsWith('ghost-');

export const isTouchPointerEvent = (event: Event): boolean =>
  (typeof TouchEvent !== 'undefined' && event instanceof TouchEvent) ||
  (typeof PointerEvent !== 'undefined' &&
    event instanceof PointerEvent &&
    (event.pointerType === 'touch' || event.pointerType === 'pen'));

export const hasNumericGhostCoordinates = (
  annotation: GhostCoordinatesCandidate
): annotation is GhostCoordinates => {
  if (!isGhostAnnotationId(annotation.id)) {
    return false;
  }
  if (!('x' in annotation) || !('y' in annotation)) {
    return false;
  }
  return isNumber(annotation.x) && isNumber(annotation.y);
};

export const hasNumericCustomOffset = (
  annotation: CogniteAnnotation | undefined
): annotation is AnnotationWithNumericCustomOffset => {
  if (!annotation) {
    return false;
  }

  const candidate = annotation as AnnotationWithCustomOffset;
  if (!candidate.customOffset) {
    return false;
  }

  return (
    isNumber(candidate.customOffset.x) && isNumber(candidate.customOffset.y)
  );
};
